/**
 * Created by Ella Ma on 04/12/2019.
 * Description:
 * ------ maintenance history ------
 * Updated by Daniel on 06/01/2021. Added 'inlcude specific entity itself' option for special entity
 */

import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { MultiSelDropdownFilterConfig } from '../../../widgets/multi-sel-dropdown-filter/multi-sel-dropdown-filter.model';
import { EntityDropdownConfig, EntityDropdownEventType, EntityDropdownActionType } from './entity-dropdown/entity-dropdown.model';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../../redux';
import { fullEntityTypeSelector } from '../../../redux/reducers/entity-type.reducer';
import { Subscription } from 'rxjs';
import { relationshipTypeSelector } from '../../../redux/reducers/relationship-type.reducer';
import { filter, take } from 'rxjs/operators';
import { Entity } from '../../../tamalelibs/models/entity.model';
import { EntityService } from '../../../tamalelibs/services/entity.service';
import { FocusSettinActionType, FocusSettingConfig, FocusSettingEventType, UsePage } from './focus-setting.model';
import { ArrayHelperService } from '../../../tamalelibs/services/array-helper.service';

@Component({
    selector: 'tam-focus-setting',
    templateUrl: './focus-setting.component.html',
    styleUrls: ['./focus-setting.component.scss']
})
export class FocusSettingComponent implements OnInit, OnDestroy {

    @Input() config: FocusSettingConfig;

    focus = 0;

    enableFocusEntityType = false;
    entityTypeConfig: MultiSelDropdownFilterConfig = new MultiSelDropdownFilterConfig();
    enableOneDegree = false;
    focusEntityData: any;

    enableFocusRelationType = false;
    focusRelationshipTypeConfig: MultiSelDropdownFilterConfig = new MultiSelDropdownFilterConfig();
    focusRelationData: any;

    entityRelationshipType = false;
    entityRelationshipTypeConfig: MultiSelDropdownFilterConfig = new MultiSelDropdownFilterConfig();
    specificEntityConfig: EntityDropdownConfig = new EntityDropdownConfig();
    entityRelationshipData: any;
    specificEntityId: any;
    includeSpecificEntityItself = false;

    enableCurrentUserRelationship = false;
    entityCurrentUserRelationshipConfig: MultiSelDropdownFilterConfig = new MultiSelDropdownFilterConfig();
    currentUserRelationshipData: any;

    usePage = UsePage;

    private _subscriptions$: Subscription[] = [];

    constructor(
        private _store: Store<AppState>,
        private _entityService: EntityService,
    ) { }

    ngOnInit() {
        this._initEntityTypeData();
        this._initFocusRelationshipData();
        this._initEntityRelationshipTypeData();
        this._initEntityCurrentUserRelationshipData();
        this._initSubscriptions();
        this._initFoucusData();
    }

    ngOnDestroy(): void {
        this._subscriptions$.forEach(item => item.unsubscribe());
    }

    changeEnableFocusRelationType() {
        this.focusRelationshipTypeConfig.disabledInput = !this.enableFocusRelationType;
        this.config.config.focus.enableFocusRelationType = this.enableFocusRelationType;
    }

    changeEnableFocusEntityType() {
        this.entityTypeConfig.disabledInput = !this.enableFocusEntityType;
        this.config.config.focus.enableFocusEntityType = this.enableFocusEntityType;
    }

    changeEnableOneDegree() {
        this.config.config.focus.enableOneDegree = this.enableOneDegree;
    }

    changeEntityRelationshipType() {
        this.entityRelationshipTypeConfig.disabledInput = !this.entityRelationshipType;
        this.config.config.focus.entityRelationshipType = this.entityRelationshipType;
    }

    changeCurrentUserRelationship() {
        this.entityCurrentUserRelationshipConfig.disabledInput = !this.enableCurrentUserRelationship;
        this.config.config.focus.enableCurrentUserRelationship = this.enableCurrentUserRelationship;
    }

    changFocus(value) {
        if (value === 0) {
            if (this.config.config.page === this.usePage.tile) {
                this.config.config.focus.relationshipTypes = this.focusRelationData;
                this.changeEnableFocusRelationType();
            } else {
                this.config.config.focus.entityTypes = this.focusEntityData;
                this.changeEnableFocusEntityType();
            }
        } else {
            if (this.config.config.page === this.usePage.tile) {
                this.focusRelationshipTypeConfig.disabledInput = true;
            } else {
                this.entityTypeConfig.disabledInput = true;
            }
        }
        if (value === 2) {
            this.config.config.focus.relationshipTypes = this.entityRelationshipData;
            this.changeEntityRelationshipType();
        } else {
            this.entityRelationshipTypeConfig.disabledInput = true;
        }
        if (value === 3) {
            this.config.config.focus.relationshipTypes = this.currentUserRelationshipData;
            this.changeCurrentUserRelationship();
        } else {
            this.entityCurrentUserRelationshipConfig.disabledInput = true;
        }
        this.config.config.focus.type = value;
    }

    changeIncludeSpecificEntityItself() {
        this.config.config.focus.includeSpecificEntityItself = this.includeSpecificEntityItself;
    }

    private _initSubscriptions() {
        this._subscriptions$.push(
            this.entityTypeConfig.onChangeValue$.subscribe(data => {
                const value = typeof data === 'string' ? data : data.map(item => item.id);
                this.focusEntityData = value;
                this.config.config.focus.entityTypes = this.focusEntityData;

                this.config.events$.next({ type: FocusSettingEventType.valueChange });
            }),
            this.config.actions$.subscribe((action) => this._actionsHandler(action)),
            this.focusRelationshipTypeConfig.onChangeValue$.subscribe(data => {
                const value = typeof data === 'string' ? data : data.map(item => item.id);
                this.focusRelationData = value;
                this.config.config.focus.relationshipTypes = this.focusRelationData;
                this.config.events$.next({ type: FocusSettingEventType.valueChange });
            }),
            this.entityRelationshipTypeConfig.onChangeValue$.subscribe(data => {
                const value = typeof data === 'string' ? data : data.map(item => item.id);
                this.entityRelationshipData = value;
                this.config.config.focus.relationshipTypes = this.entityRelationshipData;
                this.config.events$.next({ type: FocusSettingEventType.valueChange });
            }),
            this.specificEntityConfig.events$.pipe(
                filter(item => item.type === EntityDropdownEventType.valueChange)
            ).subscribe(item => {
                this.specificEntityId = item && item.payload && item.payload['id'];
                this.config.config.focus.entityId = this.specificEntityId;
                this.config.events$.next({ type: FocusSettingEventType.valueChange });
            }),
            this.entityCurrentUserRelationshipConfig.onChangeValue$.subscribe(data => {
                const value = typeof data === 'string' ? data : data.map(item => item.id);
                this.currentUserRelationshipData = value;
                this.config.config.focus.relationshipTypes = this.currentUserRelationshipData;
                this.config.events$.next({ type: FocusSettingEventType.valueChange });
            })
        );
    }

    private _initEntityTypeData() {
        this.entityTypeConfig.disabledInput = true;
        this._subscriptions$.push(
            this._store.pipe(select(fullEntityTypeSelector))
                .subscribe(items => {
                    if (items && items.length > 0) {
                        this.entityTypeConfig.data = items.map(data => {
                            return {
                                id: data.id,
                                checked: false,
                                name: data.name
                            };
                        });
                        ArrayHelperService.sort(this.entityTypeConfig.data, 'name');
                    }
                })
        );
    }

    private _initRelationshipTypeData(data) {
        this._subscriptions$.push(
            this._store.pipe(select(relationshipTypeSelector))
                .subscribe(items => {
                    if (items && items.length > 0 && typeof items === 'object') {
                        ArrayHelperService.sort(items, 'name');
                        // tslint:disable-next-line: no-shadowed-variable
                        data.data = items.map(data => ({
                            id: data.id,
                            checked: false,
                            name: data.name
                        }));
                        ArrayHelperService.sort(data.data, 'name');
                    }
                })
        );
    }

    private _initFocusRelationshipData() {
        this.focusRelationshipTypeConfig.disabledInput = true;
        this._initRelationshipTypeData(this.focusRelationshipTypeConfig);
    }

    private _initEntityRelationshipTypeData() {
        this.entityRelationshipTypeConfig.disabledInput = true;
        this._initRelationshipTypeData(this.entityRelationshipTypeConfig);
    }

    private _initEntityCurrentUserRelationshipData() {
        this.entityCurrentUserRelationshipConfig.disabledInput = true;
        this._initRelationshipTypeData(this.entityCurrentUserRelationshipConfig);
    }

    private _initFoucusData() {
        this.focus = this.config.config.focus.type;
        const defaultConfig = this.config.config.focus;
        if (this.focus === 0) {
            if (this.config.config.page === this.usePage.tile) {
                if (defaultConfig.relationshipTypes && defaultConfig.relationshipTypes.length > 0) {
                    this.enableFocusRelationType = true;
                    this.focusRelationData = defaultConfig.relationshipTypes;
                    if (typeof this.focusRelationData === 'object') {
                        this.focusRelationData.forEach(id => {
                            const index = this.focusRelationshipTypeConfig.data.findIndex(item => item.id === id);
                            if (index !== -1) {
                                this.focusRelationshipTypeConfig.data[index].checked = true;
                            }
                        });
                    } else {
                        this.focusRelationshipTypeConfig.data.forEach(item => {
                            item.checked = true;
                        });
                    }
                } else {
                    this.enableFocusRelationType = false;
                }
                this.changeEnableFocusRelationType();
            } else {
                if (defaultConfig.entityTypes && defaultConfig.entityTypes.length > 0) {
                    this.enableFocusEntityType = true;
                    this.focusEntityData = defaultConfig.entityTypes;
                    if (typeof this.focusEntityData === 'object') {
                        this.focusEntityData.forEach(id => {
                            const index = this.entityTypeConfig.data.findIndex(item => item.id === id);
                            if (index !== -1) {
                                this.entityTypeConfig.data[index].checked = true;
                            }
                        });
                    } else {
                        this.entityTypeConfig.data.forEach(item => {
                            item.checked = true;
                        });
                    }
                } else {
                    this.enableFocusEntityType = false;
                }
                this.enableOneDegree = defaultConfig.enableOneDegree;
                this.changeEnableFocusEntityType();
            }
        } else if (this.focus === 2) {
            this.specificEntityId = defaultConfig.entityId;
            this._entityService.getEntityDetailWithoutAdhoc(this.specificEntityId).pipe(
                take(1)
            ).subscribe(response => {
                if (response) {
                    const entity = Entity.parse(response);
                    this.specificEntityConfig.actions$.next({ type: EntityDropdownActionType.search, payload: entity });
                }
            });
            if (defaultConfig.relationshipTypes && defaultConfig.relationshipTypes.length > 0) {
                this.entityRelationshipType = true;
                this.entityRelationshipData = defaultConfig.relationshipTypes;
                if (typeof this.entityRelationshipData === 'object') {
                    this.entityRelationshipData.forEach(id => {
                        const index = this.entityRelationshipTypeConfig.data.findIndex(item => item.id === id);
                        if (index !== -1) {
                            this.entityRelationshipTypeConfig.data[index].checked = true;
                        }
                    });
                } else {
                    this.entityRelationshipTypeConfig.data.forEach(item => {
                        item.checked = true;
                    });
                }
                if (defaultConfig.includeSpecificEntityItself) {
                    this.includeSpecificEntityItself = true;
                } else {
                    this.includeSpecificEntityItself = false;
                }
            } else {
                this.entityRelationshipType = false;
                this.includeSpecificEntityItself = false;
            }
            this.changeEntityRelationshipType();
        } else if (this.focus === 3) {
            if (defaultConfig.relationshipTypes && defaultConfig.relationshipTypes.length > 0) {
                this.enableCurrentUserRelationship = true;
                this.currentUserRelationshipData = defaultConfig.relationshipTypes;
                if (typeof this.currentUserRelationshipData === 'object') {
                    this.currentUserRelationshipData.forEach(id => {
                        const index = this.entityCurrentUserRelationshipConfig.data.findIndex(item => item.id === id);
                        if (index !== -1) {
                            this.entityCurrentUserRelationshipConfig.data[index].checked = true;
                        }
                    });
                } else {
                    this.entityCurrentUserRelationshipConfig.data.forEach(item => {
                        item.checked = true;
                    });
                }
            } else {
                this.enableCurrentUserRelationship = false;
            }
            this.changeCurrentUserRelationship();
        }
    }

    private _actionsHandler(action) {
        if (action.type === FocusSettinActionType.refreshFocus) {
            this._initFoucusData();
            if (this.focus === 0 && this.config.config.disabledEnabledFocusRelationship) {
                this.focusRelationshipTypeConfig.clear$.next();
            }
        }
    }
}
